<template>

  <modalo
    :title="cancelReason.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => cancelReason">

    <form id="cancel-reason-form" v-on:submit.prevent="saveCancelReason(cancelReason)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="cancelReason.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="cancel-reason-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteCancelReason(cancelReason._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'CancelReasonForm',
  components: {
  },
  props: [
    'initCancelReason'
  ],
  data () {
    return {
      loading: false,
      cancelReason: this.defaultValues(this.initCancelReason),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveCancelReason
    */
    saveCancelReason (data) {
      if (data._id) this.updateCancelReason(data)
      else this.createCancelReason(data)
    },
    /*
    createCancelReason
    */
    createCancelReason (data) {
      this.loading = true

      this.$store
      .dispatch('createCancelReason', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateCancelReason
    */
    updateCancelReason (data) {
      this.loading = true

      this.$store
      .dispatch('updateCancelReason', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteCancelReason (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteCancelReason', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CancelReason/CancelReasonForm.vue